// Fun prediction markets tailored for Brian Ball
export const briansFunMarkets = [
  {
    id: 'claude-code-1',
    question: "Will Brian ship 5+ features before going to bed tonight?",
    description: "Based on the current pace of 4 features in 10 minutes, can Brian maintain this velocity?",
    options: [
      { id: 'yes-5-features', text: 'Yes, 5+ features', probability: 75, color: '#22c55e' },
      { id: 'no-less-5', text: 'No, less than 5', probability: 25, color: '#ef4444' }
    ],
    category: 'coding',
    totalPool: 2500,
    endDate: new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString(), // 8 hours
    creatorId: 'claude',
    slug: 'brian-ship-features-tonight'
  },
  {
    id: 'ai-tools-2',
    question: "Will Claude Code become Brian's most-used AI tool by October 2025?",
    description: "Given the test-driven development workflow and rapid iteration capabilities demonstrated today",
    options: [
      { id: 'claude-wins', text: 'Claude Code #1', probability: 65, color: '#8b5cf6' },
      { id: 'other-tool', text: 'Another tool wins', probability: 35, color: '#f59e0b' }
    ],
    category: 'ai',
    totalPool: 5000,
    endDate: '2025-10-01T00:00:00Z',
    creatorId: 'ai-predictor',
    slug: 'claude-code-most-used-tool'
  },
  {
    id: 'futrbet-success-3',
    question: "Will FutrBet have 100+ active users by end of September?",
    description: "After this rapid development session, will the momentum continue?",
    options: [
      { id: 'yes-100', text: 'Yes, 100+ users', probability: 40, color: '#10b981' },
      { id: 'no-under', text: 'No, under 100', probability: 60, color: '#dc2626' }
    ],
    category: 'startup',
    totalPool: 3000,
    endDate: '2025-09-30T23:59:59Z',
    creatorId: 'startup-oracle',
    slug: 'futrbet-100-users-september'
  },
  {
    id: 'test-coverage-4',
    question: "Will Brian add test panels for ALL features before shipping v1.0?",
    description: "Given the enthusiasm for the D1 test panel, will every feature get test coverage?",
    options: [
      { id: 'full-coverage', text: 'Yes, 100% test panels', probability: 70, color: '#06b6d4' },
      { id: 'partial', text: 'No, some features untested', probability: 30, color: '#fb923c' }
    ],
    category: 'development',
    totalPool: 1500,
    endDate: '2025-10-15T00:00:00Z',
    creatorId: 'tdd-advocate',
    slug: 'brian-100-percent-test-coverage'
  },
  {
    id: 'deployment-speed-5',
    question: "Will Brian deploy to production more than 10 times tomorrow?",
    description: "Tonight's deployment velocity: 3 deploys in one session. Can this pace continue?",
    options: [
      { id: 'yes-10-plus', text: 'Yes, 10+ deploys', probability: 45, color: '#a855f7' },
      { id: 'no-less-10', text: 'No, less than 10', probability: 55, color: '#64748b' }
    ],
    category: 'devops',
    totalPool: 2000,
    endDate: new Date(Date.now() + 32 * 60 * 60 * 1000).toISOString(), // 32 hours
    creatorId: 'deploy-bot',
    slug: 'brian-10-deploys-tomorrow'
  },
  {
    id: 'sleep-time-6',
    question: "What time will Brian actually go to bed tonight?",
    description: "It's already late and the coding momentum is strong...",
    options: [
      { id: 'before-2am', text: 'Before 2 AM', probability: 20, color: '#3b82f6' },
      { id: '2-3am', text: '2-3 AM', probability: 35, color: '#8b5cf6' },
      { id: '3-4am', text: '3-4 AM', probability: 30, color: '#ec4899' },
      { id: 'after-4am', text: 'After 4 AM (or not at all)', probability: 15, color: '#ef4444' }
    ],
    category: 'lifestyle',
    totalPool: 4000,
    endDate: new Date(Date.now() + 6 * 60 * 60 * 1000).toISOString(),
    creatorId: 'sleep-tracker',
    slug: 'brian-bedtime-tonight'
  },
  {
    id: 'weekend-project-7',
    question: "Will Brian build another complete app this weekend?",
    description: "After transforming FastFiles to FutrBet in one night, what's next?",
    options: [
      { id: 'yes-new-app', text: 'Yes, new app incoming', probability: 60, color: '#14b8a6' },
      { id: 'no-rest', text: 'No, taking a break', probability: 40, color: '#f97316' }
    ],
    category: 'projects',
    totalPool: 3500,
    endDate: '2025-09-29T00:00:00Z',
    creatorId: 'weekend-warrior',
    slug: 'brian-weekend-project'
  },
  {
    id: 'git-commits-8',
    question: "How many git commits will Brian make in the next 24 hours?",
    description: "Current pace: 15+ commits tonight alone",
    options: [
      { id: 'under-20', text: 'Under 20', probability: 15, color: '#94a3b8' },
      { id: '20-40', text: '20-40 commits', probability: 35, color: '#22d3ee' },
      { id: '40-60', text: '40-60 commits', probability: 35, color: '#818cf8' },
      { id: 'over-60', text: 'Over 60 commits', probability: 15, color: '#f472b6' }
    ],
    category: 'git',
    totalPool: 2800,
    endDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
    creatorId: 'git-oracle',
    slug: 'brian-24h-commit-count'
  },
  {
    id: 'refactor-9',
    question: "Will Brian refactor CreateMarket.tsx before v1.0?",
    description: "It's at 800+ lines and growing. Will it get split into smaller components?",
    options: [
      { id: 'yes-refactor', text: 'Yes, refactor incoming', probability: 80, color: '#84cc16' },
      { id: 'no-keep', text: 'No, it stays huge', probability: 20, color: '#dc2626' }
    ],
    category: 'code-quality',
    totalPool: 1800,
    endDate: '2025-10-01T00:00:00Z',
    creatorId: 'clean-code',
    slug: 'createmarket-refactor'
  },
  {
    id: 'ai-pair-10',
    question: "Will Brian discover 3+ new Claude Code features tonight?",
    description: "Already discovered test panels, batch tool calls, and rapid deployment. What's next?",
    options: [
      { id: 'yes-3-plus', text: 'Yes, 3+ discoveries', probability: 55, color: '#0ea5e9' },
      { id: 'no-less-3', text: 'No, less than 3', probability: 45, color: '#ea580c' }
    ],
    category: 'ai',
    totalPool: 2200,
    endDate: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    creatorId: 'claude',
    slug: 'brian-claude-discoveries-tonight'
  }
];

// Categories for filtering
export const marketCategories = [
  'coding',
  'ai',
  'startup',
  'development',
  'devops',
  'lifestyle',
  'projects',
  'git',
  'code-quality'
];

// Fun facts about tonight's session
export const sessionStats = {
  featuresBuilt: 4,
  deploymentsCompleted: 3,
  testsWritten: 10,
  linesOfCodeAdded: 2000,
  coffeeConsumed: '???',
  velocityLevel: 'EXTREME',
  currentMood: '🚀'
};